import { useRef } from 'react';

// https://habr.com/en/articles/752818/
const usePrevious = <T>(value: T): T | undefined => {
  const currentRef = useRef(value);
  const previousRef = useRef<T | undefined>(undefined);
  if (currentRef.current !== value) {
    previousRef.current = currentRef.current;
    currentRef.current = value;
  }
  return previousRef.current;
};

export default usePrevious;
